import StandardBlockModel from 'Models/Blocks/StandardBlock//StandardBlockModel.interface';
import useCurrentPage from 'Shared/Hooks/useCurrentPage';
import ProductPageStandardBlock from './ProductPageStandardBlock';
import StandardBlockDefault from './StandardBlockDefault';

type PropTypes = {
  content: StandardBlockModel;
};

function StandardBlock({ content }: PropTypes) {
  const { pageType } = useCurrentPage();
  const isProductPage = pageType === 'ProductPage';
  return isProductPage ? (
    <ProductPageStandardBlock content={content} />
  ) : (
    <StandardBlockDefault content={content} />
  );
}

export default StandardBlock;
